import { Order } from '@/coreDomainsModule/entities/order';
import { UserAccount } from '../entities/users';

/**
 * ファクトリー
 */
export class UserAccountFactory {
  /**
   * IParentBusinessを生成する
   * @param initialData - 初期値
   */
  public static create = (initialData: Partial<UserAccount> = {}): UserAccount => {
    const userAccount: Required<UserAccount> = {
      email: initialData.email ?? '',
      name: initialData.name ?? '',
      organizationId: initialData.organizationId ?? '',
      role: initialData.role ?? '',
      profile: initialData.profile ?? {
        groupName: '',
        position: '',
        description: '',
      },
      createdAt: initialData.createdAt ?? 0,
      updatedAt: initialData.updatedAt ?? 0,
    };
    return userAccount;
  };
}
